// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__0MWME","whiteVariant":"Button_whiteVariant__jBZcj"};